@if (style === 'logged-layout') {
  <app-logged-layout></app-logged-layout>
} @else if (style === 'logout-layout') {
  <app-logout-layout></app-logout-layout>
}
